import { createContext, useState, useContext, useEffect } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";

const NotificationContext = createContext();

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity });
  };

  const hideNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const value = { showNotification, hideNotification };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={hideNotification}
        TransitionComponent={SlideTransition}
        anchorOrigin={{
          vertical: isMobileView ? "top" : "bottom",
          horizontal: "left",
        }}
        sx={{
          zIndex: 999999,
          pointerEvents: "none",

          "& .MuiAlert-root": {
            pointerEvents: "auto",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: isMobileView ? "12px" : "14px",
            fontWeight: 500,
            letterSpacing: isMobileView ? "0.2px" : "0.3px",
          },
        }}
      >
        <Alert
          onClose={hideNotification}
          severity={notification.severity}
          sx={{
            width: isMobileView ? "50vw" : "420px",
            minWidth: isMobileView ? "220px" : "320px",
            maxWidth: isMobileView ? "50vw" : "420px",
            fontFamily: "'Montserrat', sans-serif !important",
            fontSize: isMobileView ? "12px !important" : "14px !important",
            fontWeight: 500,
            letterSpacing: "0.3px",
            zIndex: 999999,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
            borderRadius: "8px",
            py: isMobileView ? 0.25 : 0.75,
            px: isMobileView ? 1 : 2,
            "& .MuiAlert-icon": {
              fontSize: isMobileView ? "16px" : "20px",
            },
            "& .MuiAlert-message": {
              fontFamily: "'Montserrat', sans-serif",
              fontSize: isMobileView ? "12px" : "14px",
              fontWeight: 500,
            },
            "& .MuiAlert-action": {
              padding: "4px 0 4px 8px",
              "& button": {
                fontFamily: "'Montserrat', sans-serif",
              },
            },
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within NotificationProvider");
  }
  return context;
};

export default NotificationContext;
